import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

export const ThemeToggle: React.FC = () => {
  const { theme, setTheme } = useTheme();
  const isLight = theme === "light";

  return (
    <div
      role="group"
      aria-label="Tema"
      className="inline-flex items-center p-1 rounded-full bg-lyrax-bg border border-lyrax-border/80"
    >
      <button
        type="button"
        onClick={() => setTheme("light")}
        className={`p-1.5 rounded-full transition-all ${
          isLight
            ? "bg-lyrax-primary text-lyrax-primary-ink shadow-sm"
            : "text-lyrax-text-secondary hover:text-lyrax-text"
        }`}
        aria-label="Modo claro"
        aria-pressed={isLight}
        title="Claro"
      >
        <Sun className="w-4 h-4" />
      </button>
      <button
        type="button"
        onClick={() => setTheme("dark")}
        className={`p-1.5 rounded-full transition-all ${
          !isLight
            ? "bg-lyrax-primary text-lyrax-primary-ink shadow-sm"
            : "text-lyrax-text-secondary hover:text-lyrax-text"
        }`}
        aria-label="Modo oscuro"
        aria-pressed={!isLight}
        title="Oscuro"
      >
        <Moon className="w-4 h-4" />
      </button>
    </div>
  );
};
